<template>
    <div class="base-multiselect-container">
        <VueMultiselect :model-value="modelValue" :options="options" :multiple="true" :close-on-select="false"
            :clear-on-select="true" :preserve-search="true" :placeholder="modelValue.length > 0 ? '' : placeholder" :label="labelKey"
            :track-by="valueKey" :loading="loading" :disabled="loading || disabled" :reduce="option => option[valueKey]"
            @update:model-value="updateValue" class="custom-multiselect" :group-values="groupValues"
            :group-label="groupLabel" select-label="" selected-label="Seleccionado" deselect-label="Quitar" :limit="1"
            :limit-text="count => `y ${count} más...`">
        </VueMultiselect>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import VueMultiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';

defineProps({
    modelValue: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    placeholder: { type: String, default: "Seleccionar..." },
    disabled: { type: Boolean, default: false },
    valueKey: { type: String, default: "id" },
    labelKey: { type: String, default: "name" },

    groupValues: { type: String, default: null },
    groupLabel: { type: String, default: null }
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (newValue) => {
    emit('update:modelValue', newValue);
};
</script>

<style>
.custom-multiselect .multiselect__tags {
    min-height: 38px;
    height: 38px;
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.custom-multiselect .multiselect__strong {
    margin-left: 5px;
    font-size: 0.85rem;
    color: #6c757d;
}

.custom-multiselect .multiselect__tag {
    margin-bottom: 0;
    margin-top: 0;
    max-width: 70%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.custom-multiselect .multiselect__placeholder {
    color: #6c757d;
    font-size: 0.9rem;
    margin-bottom: 0;  
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    padding-left: 12px;
    text-align: left;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none; 
}

.custom-multiselect .multiselect__input {
    font-size: 0.9rem;
}

.custom-spinner-multi {
    position: absolute;
    top: 1px;
    bottom: 4px;
    right: 1px;

    width: 38px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #fff;

    border-radius: 0 0.3rem 0.3rem 0;

    z-index: 50;
}

.custom-spinner {
    width: 1.2rem !important;
    height: 1.2rem !important;
    border-width: 0.15em !important;
    color: #0d6efd;
}

.custom-multiselect .multiselect__spinner {
    height: 36px;
    width: 38px;
    top: 1px;
    right: 1px;
    background: #fff;
}

.custom-multiselect .multiselect__spinner:before,
.custom-multiselect .multiselect__spinner:after {
    width: 20px;
    height: 20px;
    margin-top: -10px;
    margin-left: -10px;

    border-top-color: #0d6efd;
}
</style>